// extracted by mini-css-extract-plugin
export default {"icon":"Verify_icon__HXK1e"};